(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cycle-care-calendar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'cycleCareCalendar.v1';
    const dailyStorageKey = 'cycleCareDaily.v1';
    const weightStorageKey = 'cycleCareWeight.v1';
    const dayMilliseconds = 86400000;

    const parseDate = (value) => {
      if (!value) return null;
      const parts = value.split('-').map(Number);
      if (parts.length !== 3 || parts.some(Number.isNaN)) return null;
      return new Date(parts[0], parts[1] - 1, parts[2], 12);
    };

    const dateKey = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const addDays = (date, amount) => {
      const next = new Date(date);
      next.setDate(next.getDate() + amount);
      return next;
    };

    const differenceInDays = (later, earlier) => Math.round((later - earlier) / dayMilliseconds);

    const startOfToday = () => {
      const today = new Date();
      return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12);
    };

    const init = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const hero = root.querySelector('.cycle-care__hero');
      const spaceOpenButtons = [...root.querySelectorAll('[data-open-space]')];
      const spacePanels = [...root.querySelectorAll('[data-care-space-panel]')];
      const spaceCloseButtons = [...root.querySelectorAll('[data-close-space]')];
      const welcomeNotePanels = [...root.querySelectorAll('[data-welcome-note]')];
      const careNeedButtons = [...root.querySelectorAll('[data-care-need]')];
      const careNeedResponse = root.querySelector('[data-care-need-response]');
      const careNeedResponseTitle = root.querySelector('[data-care-need-response-title]');
      const careNeedResponseBody = root.querySelector('[data-care-need-response-body]');
      const careNeedResponseRitual = root.querySelector('[data-care-need-response-ritual]');
      const careNeedOpen = root.querySelector('[data-care-need-open]');
      const careGardenPetals = [...root.querySelectorAll('[data-care-garden-petal]')];
      const careGardenCounts = [...root.querySelectorAll('[data-care-garden-count]')];
      const careGardenCountLabels = [...root.querySelectorAll('[data-care-garden-count-label]')];
      const careGardenMessages = [...root.querySelectorAll('[data-care-garden-message]')];
      const form = root.querySelector('[data-cycle-form]');
      const startInput = root.querySelector('[data-cycle-start]');
      const monthSelect = root.querySelector('[data-cycle-month]');
      const daySelect = root.querySelector('[data-cycle-day]');
      const yearSelect = root.querySelector('[data-cycle-year]');
      const todayButton = root.querySelector('[data-cycle-today]');
      const periodLengthInput = root.querySelector('[data-period-length]');
      const cycleLengthInput = root.querySelector('[data-cycle-length]');
      const status = root.querySelector('[data-cycle-status]');
      const clearDialog = root.querySelector('[data-clear-dialog]');
      const clearButton = root.querySelector('[data-clear-cycle]');
      const confirmClearButton = root.querySelector('[data-confirm-clear]');
      const results = root.querySelector('[data-cycle-results]');
      const calendarTitle = root.querySelector('[data-calendar-title]');
      const calendarHead = root.querySelector('[data-calendar-head]');
      const calendarBody = root.querySelector('[data-calendar-body]');
      const upcomingList = root.querySelector('[data-upcoming-list]');
      const weightRoot = root.querySelector('[data-weight-goals]');
      const weightDirectionButtons = [...weightRoot.querySelectorAll('[data-weight-direction] [data-value]')];
      const weightHabitButtons = [...weightRoot.querySelectorAll('[data-weight-habit] [data-value]')];
      const weightDescription = weightRoot.querySelector('[data-weight-description]');
      const weightSave = weightRoot.querySelector('[data-weight-save]');
      const weightStatus = weightRoot.querySelector('[data-weight-status]');
      const dailyRoot = root.querySelector('[data-daily-care]');
      const dailyFocusButtons = [...dailyRoot.querySelectorAll('[data-daily-focus-value]')];
      const dailyFocusDescription = dailyRoot.querySelector('[data-daily-focus-description]');
      const dailyProgress = dailyRoot.querySelector('[data-daily-progress]');
      const dailyProgressbar = dailyRoot.querySelector('[data-daily-progressbar]');
      const dailyProgressFill = dailyRoot.querySelector('[data-daily-progress-fill]');
      const dailyStreak = dailyRoot.querySelector('[data-daily-streak]');
      const dailyStatus = dailyRoot.querySelector('[data-daily-status]');
      const dailyEnergyButtons = [...dailyRoot.querySelectorAll('[data-daily-energy]')];
      const dailyLessonPanels = [...dailyRoot.querySelectorAll('[data-daily-lesson]')];
      const dailyLessonButton = dailyRoot.querySelector('[data-daily-lesson-done]');
      const dailyActionCard = dailyRoot.querySelector('[data-daily-task="action"]');
      const dailyActionTitle = dailyRoot.querySelector('[data-daily-action-title]');
      const dailyActionBody = dailyRoot.querySelector('[data-daily-action-body]');
      const dailyActionAnother = dailyRoot.querySelector('[data-daily-action-another]');
      const dailyActionButton = dailyRoot.querySelector('[data-daily-action-done]');
      const dailyWinButtons = [...dailyRoot.querySelectorAll('[data-daily-win]')];
      const dailyReward = dailyRoot.querySelector('[data-care-reward]');
      const bodyMoodButtons = [...dailyRoot.querySelectorAll('[data-body-mood]')];
      const bodySleepButtons = [...dailyRoot.querySelectorAll('[data-body-sleep]')];
      const bodySymptomButtons = [...dailyRoot.querySelectorAll('[data-body-symptom]')];
      const bodyNote = dailyRoot.querySelector('[data-body-note]');
      const bodySave = dailyRoot.querySelector('[data-body-save]');
      const bodyReflection = dailyRoot.querySelector('[data-body-reflection]');
      const resetRoot = dailyRoot.querySelector('[data-care-reset]');
      const resetTime = resetRoot.querySelector('[data-reset-time]');
      const resetCue = resetRoot.querySelector('[data-reset-cue]');
      const resetToggle = resetRoot.querySelector('[data-reset-toggle]');
      const quizRoot = dailyRoot.querySelector('[data-care-quiz]');
      const quizPanels = [...quizRoot.querySelectorAll('[data-quiz-question]')];
      const quizButtons = [...quizRoot.querySelectorAll('[data-quiz-choice]')];
      const quizFeedback = quizRoot.querySelector('[data-quiz-feedback]');
      const careSummaryRoot = root.querySelector('[data-care-summary]');
      const careSummaryCreate = careSummaryRoot.querySelector('[data-summary-create]');
      const careSummaryCopy = careSummaryRoot.querySelector('[data-summary-copy]');
      const careSummaryDownload = careSummaryRoot.querySelector('[data-summary-download]');
      const careSummaryOutput = careSummaryRoot.querySelector('[data-summary-output]');
      const careSummaryText = careSummaryRoot.querySelector('[data-summary-text]');
      const careSummaryStatus = careSummaryRoot.querySelector('[data-summary-status]');
      const cycleCompassTitle = root.querySelector('[data-cycle-compass-title]');
      const cycleCompassBody = root.querySelector('[data-cycle-compass-body]');
      const cycleCompassDay = root.querySelector('[data-cycle-compass-day]');
      const cycleCompassNext = root.querySelector('[data-cycle-compass-next]');
      const cycleSupportShortcuts = [...root.querySelectorAll('[data-cycle-support-shortcut]')];
      const cycleShortcutResponse = root.querySelector('[data-cycle-shortcut-response]');
      const cycleShortcutTitle = root.querySelector('[data-cycle-shortcut-title]');
      const cycleShortcutBody = root.querySelector('[data-cycle-shortcut-body]');
      const cycleShortcutOpen = root.querySelector('[data-cycle-shortcut-open]');
      const cycleAdviceItems = [...root.querySelectorAll('[data-cycle-advice]')];
      const recipesRoot = root.querySelector('[data-daily-recipes]');
      const recipeGrid = recipesRoot.querySelector('[data-recipe-grid]');
      const recipeDate = recipesRoot.querySelector('[data-recipe-date]');
      const recipeAnother = recipesRoot.querySelector('[data-recipe-another]');
      const recipeToday = recipesRoot.querySelector('[data-recipe-today]');
      const recipeStatus = recipesRoot.querySelector('[data-recipe-status]');
      const locale = document.documentElement.lang || navigator.language || 'en';
      const today = startOfToday();
      const todayKey = dateKey(today);
      const nextLocalMidnight = new Date();
      nextLocalMidnight.setHours(24, 0, 2, 0);
      const midnightRefresh = window.setTimeout(() => window.location.reload(), Math.max(1000, nextLocalMidnight.getTime() - Date.now()));
      root.addEventListener('shopify:section:unload', () => window.clearTimeout(midnightRefresh), { once: true });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && dateKey(startOfToday()) !== todayKey) window.location.reload();
      });
      let viewMonth = new Date(today.getFullYear(), today.getMonth(), 1, 12);
      let savedCycle = null;
      let dailyState = { focus: 'routine', days: {} };
      let weightState = { direction: 'habits', habit: 'regular_meals' };
      let recipeOffsets = { breakfast: 0, lunch: 0, dinner: 0, snack: 0 };
      let lastSpaceTrigger = null;
      let resetSeconds = 60;
      let resetTimer = null;
      let resetRunning = false;
      const utcDay = Math.floor(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) / dayMilliseconds);

      welcomeNotePanels.forEach((panel, index) => {
        panel.hidden = index !== Math.abs(utcDay) % welcomeNotePanels.length;
      });

      const runViewChange = (change) => {
        if (typeof document.startViewTransition === 'function') {
          document.startViewTransition(change);
          return;
        }
        change();
      };

      const closeSpace = () => {
        runViewChange(() => {
          spacePanels.forEach((panel) => {
            panel.hidden = true;
          });
          spaceOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
          hero.hidden = false;
          root.removeAttribute('data-active-space');
          root.scrollIntoView({ block: 'start' });
          if (lastSpaceTrigger) lastSpaceTrigger.focus({ preventScroll: true });
        });
      };

      const openSpace = (name, trigger) => {
        const panel = spacePanels.find((candidate) => candidate.dataset.careSpacePanel === name);
        if (!panel) return;
        lastSpaceTrigger = trigger;
        runViewChange(() => {
          hero.hidden = true;
          spacePanels.forEach((candidate) => {
            candidate.hidden = candidate !== panel;
          });
          spaceOpenButtons.forEach((button) => {
            button.setAttribute('aria-expanded', String(button === trigger));
          });
          root.dataset.activeSpace = name;
          panel.focus({ preventScroll: true });
          root.scrollIntoView({ block: 'start' });
        });
      };

      spaceOpenButtons.forEach((button) => {
        button.addEventListener('click', () => openSpace(button.dataset.openSpace, button));
      });

      spaceCloseButtons.forEach((button) => {
        button.addEventListener('click', closeSpace);
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && root.dataset.activeSpace) closeSpace();
      });

      cycleSupportShortcuts.forEach((button) => {
        button.addEventListener('click', () => {
          cycleSupportShortcuts.forEach((candidate) => {
            candidate.setAttribute('aria-pressed', String(candidate === button));
          });
          cycleShortcutTitle.textContent = button.dataset.responseTitle;
          cycleShortcutBody.textContent = button.dataset.responseBody;
          cycleShortcutOpen.dataset.target = button.dataset.cycleSupportShortcut;
          cycleShortcutOpen.disabled = false;
          cycleShortcutResponse.hidden = false;
        });
      });

      cycleShortcutOpen.addEventListener('click', () => {
        const advice = cycleAdviceItems.find((item) => item.dataset.cycleAdvice === cycleShortcutOpen.dataset.target);
        if (!advice) return;
        advice.open = true;
        advice.scrollIntoView({
          behavior: 'instant',
          block: 'center'
        });
        const summary = advice.querySelector('summary');
        if (summary) summary.focus({ preventScroll: true });
      });

      const appendOption = (select, value, label) => {
        const option = document.createElement('option');
        option.value = String(value);
        option.textContent = String(label);
        select.append(option);
      };

      const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'short' });
      for (let month = 1; month <= 12; month += 1) {
        appendOption(monthSelect, month, monthFormatter.format(new Date(2024, month - 1, 1, 12)));
      }
      for (let day = 1; day <= 31; day += 1) appendOption(daySelect, day, day);
      for (let year = today.getFullYear(); year >= today.getFullYear() - 10; year -= 1) {
        appendOption(yearSelect, year, year);
      }

      const setDateParts = (date) => {
        monthSelect.value = String(date.getMonth() + 1);
        daySelect.value = String(date.getDate());
        yearSelect.value = String(date.getFullYear());
        startInput.value = dateKey(date);
      };

      const syncDateParts = () => {
        const year = Number(yearSelect.value);
        const month = Number(monthSelect.value);
        const day = Number(daySelect.value);
        if (!year || !month || !day) {
          startInput.value = '';
          return null;
        }
        const candidate = new Date(year, month - 1, day, 12);
        const isRealDate = candidate.getFullYear() === year
          && candidate.getMonth() === month - 1
          && candidate.getDate() === day;
        startInput.value = isRealDate ? dateKey(candidate) : '';
        return isRealDate ? candidate : null;
      };

      [monthSelect, daySelect, yearSelect].forEach((select) => {
        select.addEventListener('change', () => {
          syncDateParts();
          status.textContent = '';
        });
      });

      todayButton.addEventListener('click', () => {
        setDateParts(today);
        status.textContent = '';
      });

      const getDailyEntry = () => dailyState.days[todayKey] || {};

      const ensureDailyEntry = () => {
        if (!dailyState.days[todayKey]) dailyState.days[todayKey] = {};
        return dailyState.days[todayKey];
      };

      const dailyEntryComplete = (entry) => Boolean(entry.energy && entry.lesson && entry.action);

      const dailyEntryHasCare = (entry) => Boolean(entry && (
        entry.need
        || entry.energy
        || entry.lesson
        || entry.action
        || entry.win
        || entry.reset
        || entry.quiz
        || (entry.body && (entry.body.mood || entry.body.sleep || entry.body.note || (Array.isArray(entry.body.symptoms) && entry.body.symptoms.length)))
      ));

      const dailyReturnCount = () => Object.values(dailyState.days).filter(dailyEntryHasCare).length;

      const renderCareGarden = () => {
        const returnCount = dailyReturnCount();
        const returnLabel = returnCount === 1 ? dailyRoot.dataset.streakOne : dailyRoot.dataset.streakMany;
        careGardenCounts.forEach((element) => { element.textContent = String(returnCount); });
        careGardenCountLabels.forEach((element) => { element.textContent = returnLabel; });
        careGardenPetals.forEach((petal, index) => {
          petal.classList.toggle('is-grown', index < Math.min(returnCount, careGardenPetals.length));
          petal.style.setProperty('--petal-delay', String(index));
        });
        const gardenMessage = returnCount === 0
          ? root.dataset.gardenEmpty
          : returnCount < careGardenPetals.length
            ? root.dataset.gardenGrowing
            : root.dataset.gardenBlooming;
        careGardenMessages.forEach((element) => { element.textContent = gardenMessage; });
      };

      const renderCareNeed = () => {
        const entry = getDailyEntry();
        const selected = careNeedButtons.find((button) => button.dataset.careNeed === entry.need);
        careNeedButtons.forEach((button) => button.setAttribute('aria-pressed', String(button === selected)));
        careNeedResponse.hidden = !selected;
        careNeedOpen.disabled = !selected;
        if (!selected) return;
        careNeedResponseTitle.textContent = selected.dataset.responseTitle;
        careNeedResponseBody.textContent = selected.dataset.responseBody;
        careNeedResponseRitual.textContent = selected.dataset.responseRitual;
      };

      const actionLibrary = (() => {
        try {
          return JSON.parse(dailyActionCard.querySelector('[data-action-library]').textContent);
        } catch {
          return {};
        }
      })();

      const mostFrequentBodyValue = (values) => {
        const counts = values.reduce((result, value) => {
          if (value) result[value] = (result[value] || 0) + 1;
          return result;
        }, {});
        return Object.entries(counts).sort((left, right) => right[1] - left[1])[0] || null;
      };

      const bodyEntryHasContent = (entry) => {
        const body = entry && entry.body;
        return Boolean(body && (body.mood || body.sleep || (Array.isArray(body.symptoms) && body.symptoms.length) || body.note));
      };

      const renderBodyReflection = () => {
        const recentEntries = Array.from({ length: 7 }, (_, index) => dailyState.days[dateKey(addDays(today, -index))]).filter(bodyEntryHasContent);
        if (!recentEntries.length) {
          bodyReflection.textContent = dailyRoot.dataset.bodyReflectionEmpty;
          return;
        }

        const sentences = [`${recentEntries.length} ${dailyRoot.dataset.bodyReflectionDays}`];
        const topMood = mostFrequentBodyValue(recentEntries.map((entry) => entry.body.mood));
        const topSymptom = mostFrequentBodyValue(recentEntries.flatMap((entry) => Array.isArray(entry.body.symptoms) ? entry.body.symptoms.filter((value) => value !== 'none') : []));

        if (topMood && topMood[1] > 1) {
          const moodButton = bodyMoodButtons.find((button) => button.dataset.bodyMood === topMood[0]);
          if (moodButton) sentences.push(`${dailyRoot.dataset.bodyReflectionMood} ${moodButton.textContent.trim()} (${topMood[1]}).`);
        }
        if (topSymptom && topSymptom[1] > 1) {
          const symptomButton = bodySymptomButtons.find((button) => button.dataset.bodySymptom === topSymptom[0]);
          if (symptomButton) sentences.push(`${dailyRoot.dataset.bodyReflectionNoted} ${symptomButton.textContent.trim()} (${topSymptom[1]}).`);
        }
        bodyReflection.textContent = sentences.join(' ');
      };

      const renderBodyLog = (entry) => {
        const body = entry && entry.body && typeof entry.body === 'object' ? entry.body : {};
        bodyMoodButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.bodyMood === body.mood)));
        bodySleepButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.bodySleep === body.sleep)));
        const symptoms = Array.isArray(body.symptoms) ? body.symptoms : [];
        bodySymptomButtons.forEach((button) => button.setAttribute('aria-pressed', String(symptoms.includes(button.dataset.bodySymptom))));
        if (document.activeElement !== bodyNote) bodyNote.value = typeof body.note === 'string' ? body.note : '';
        renderBodyReflection();
      };

      const renderReset = () => {
        resetTime.textContent = `${resetSeconds}s`;
        resetRoot.classList.toggle('is-running', resetRunning);
        if (resetSeconds === 0) {
          resetCue.textContent = resetRoot.dataset.completeLabel;
          resetToggle.textContent = resetRoot.dataset.againLabel;
          return;
        }
        if (resetRunning) {
          const elapsed = 60 - resetSeconds;
          resetCue.textContent = Math.floor(elapsed / 6) % 2 === 0 ? resetRoot.dataset.inLabel : resetRoot.dataset.outLabel;
          resetToggle.textContent = resetRoot.dataset.pauseLabel;
          return;
        }
        resetCue.textContent = resetRoot.dataset.readyLabel;
        resetToggle.textContent = resetSeconds < 60 ? resetRoot.dataset.resumeLabel : resetRoot.dataset.startLabel;
      };

      const renderQuiz = (entry) => {
        const quizIndex = Math.abs(utcDay) % quizPanels.length;
        const activePanel = quizPanels[quizIndex];
        quizPanels.forEach((panel, index) => {
          panel.hidden = index !== quizIndex;
        });
        const quizState = entry.quiz && entry.quiz.index === quizIndex ? entry.quiz : null;
        quizButtons.forEach((button) => {
          const selected = quizState && String(quizState.answer) === button.dataset.quizChoice;
          button.setAttribute('aria-pressed', String(Boolean(selected)));
        });
        if (!quizState) {
          quizFeedback.textContent = '';
          return;
        }
        const resultLabel = quizState.correct ? quizRoot.dataset.correctLabel : quizRoot.dataset.tryLabel;
        quizFeedback.textContent = `${resultLabel} ${activePanel.dataset.explanation}`;
      };

      const renderDailyPlay = (entry) => {
        resetRoot.classList.toggle('is-complete', Boolean(entry.reset));
        renderReset();
        renderQuiz(entry);
      };

      const renderDaily = () => {
        const focusValues = ['prepared', 'comfort', 'routine', 'patterns', 'nourish', 'restore'];
        if (!focusValues.includes(dailyState.focus)) dailyState.focus = 'routine';
        const selectedFocus = dailyFocusButtons.find((button) => button.dataset.dailyFocusValue === dailyState.focus);
        dailyFocusButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button === selectedFocus));
        });
        dailyFocusDescription.textContent = selectedFocus.dataset.description;

        const entry = getDailyEntry();
        const focusActions = Array.isArray(actionLibrary[dailyState.focus]) ? actionLibrary[dailyState.focus] : [];
        const actionOffset = Number.isInteger(entry.actionVariant) ? entry.actionVariant : 0;
        const actionIndex = focusActions.length ? (Math.abs(utcDay) + actionOffset) % focusActions.length : 0;
        const [actionTitle = '', actionBody = ''] = String(focusActions[actionIndex] || '').split('^');
        dailyActionTitle.textContent = actionTitle;
        dailyActionBody.textContent = actionBody;

        const lessonIndex = Math.abs(Math.floor(today.getTime() / dayMilliseconds)) % dailyLessonPanels.length;
        dailyLessonPanels.forEach((panel, index) => {
          panel.hidden = index !== lessonIndex;
        });

        dailyEnergyButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(entry.energy === button.dataset.dailyEnergy));
        });
        dailyLessonButton.setAttribute('aria-pressed', String(Boolean(entry.lesson)));
        dailyActionButton.setAttribute('aria-pressed', String(Boolean(entry.action)));
        dailyWinButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(entry.win === button.dataset.dailyWin));
        });
        renderBodyLog(entry);

        const completed = [Boolean(entry.energy), Boolean(entry.lesson), Boolean(entry.action)];
        dailyRoot.querySelector('[data-daily-task="energy"]').classList.toggle('is-complete', completed[0]);
        dailyRoot.querySelector('[data-daily-task="lesson"]').classList.toggle('is-complete', completed[1]);
        dailyActionCard.classList.toggle('is-complete', completed[2]);

        const completedCount = completed.filter(Boolean).length;
        dailyProgress.textContent = `${completedCount}/3`;
        dailyProgressbar.setAttribute('aria-valuenow', String(completedCount));
        dailyProgressFill.style.width = `${(completedCount / 3) * 100}%`;

        const returnCount = dailyReturnCount();
        const returnLabel = returnCount === 1 ? dailyRoot.dataset.streakOne : dailyRoot.dataset.streakMany;
        dailyStreak.textContent = `${returnCount} ${returnLabel}`;
        dailyReward.hidden = !dailyEntryComplete(entry);
        renderCareGarden();
        renderCareNeed();
        renderDailyPlay(entry);
      };

      const saveDaily = () => {
        const recentKeys = Object.keys(dailyState.days).sort().reverse().slice(0, 180);
        dailyState.days = Object.fromEntries(recentKeys.map((key) => [key, dailyState.days[key]]));
        try {
          window.localStorage.setItem(dailyStorageKey, JSON.stringify(dailyState));
          dailyStatus.textContent = dailyRoot.dataset.dailySaved;
        } catch {
          dailyStatus.textContent = root.dataset.storageError;
        }
        renderDaily();
      };

      const loadDaily = () => {
        try {
          const raw = window.localStorage.getItem(dailyStorageKey);
          if (raw) {
            const candidate = JSON.parse(raw);
            if (candidate && typeof candidate === 'object') {
              dailyState.focus = candidate.focus || 'routine';
              dailyState.days = candidate.days && typeof candidate.days === 'object' ? candidate.days : {};
            }
          }
        } catch {
          dailyStatus.textContent = root.dataset.storageError;
        }
        renderDaily();
      };

      dailyFocusButtons.forEach((button) => {
        button.addEventListener('click', () => {
          dailyState.focus = button.dataset.dailyFocusValue;
          saveDaily();
        });
      });

      careNeedButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const entry = ensureDailyEntry();
          entry.need = button.dataset.careNeed;
          dailyState.focus = button.dataset.careNeed;
          saveDaily();
        });
      });

      dailyEnergyButtons.forEach((button) => {
        button.addEventListener('click', () => {
          ensureDailyEntry().energy = button.dataset.dailyEnergy;
          saveDaily();
        });
      });

      dailyLessonButton.addEventListener('click', () => {
        const entry = ensureDailyEntry();
        entry.lesson = !entry.lesson;
        saveDaily();
      });

      dailyActionAnother.addEventListener('click', () => {
        const entry = ensureDailyEntry();
        const availableActions = Array.isArray(actionLibrary[dailyState.focus]) ? actionLibrary[dailyState.focus].length : 0;
        if (!availableActions) return;
        entry.actionVariant = ((Number(entry.actionVariant) || 0) + 1) % availableActions;
        entry.action = false;
        saveDaily();
        dailyStatus.textContent = dailyRoot.dataset.actionUpdated;
      });

      dailyActionButton.addEventListener('click', () => {
        const entry = ensureDailyEntry();
        entry.action = !entry.action;
        saveDaily();
      });

      dailyWinButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const entry = ensureDailyEntry();
          entry.win = entry.win === button.dataset.dailyWin ? '' : button.dataset.dailyWin;
          saveDaily();
        });
      });

      const stopResetTimer = () => {
        if (resetTimer) window.clearInterval(resetTimer);
        resetTimer = null;
        resetRunning = false;
      };

      resetToggle.addEventListener('click', () => {
        if (resetRunning) {
          stopResetTimer();
          renderReset();
          return;
        }
        if (resetSeconds === 0) resetSeconds = 60;
        resetRunning = true;
        renderReset();
        resetTimer = window.setInterval(() => {
          resetSeconds = Math.max(0, resetSeconds - 1);
          if (resetSeconds === 0) {
            stopResetTimer();
            ensureDailyEntry().reset = true;
            saveDaily();
            return;
          }
          renderReset();
        }, 1000);
      });

      quizButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const quizIndex = Math.abs(utcDay) % quizPanels.length;
          const activePanel = quizPanels[quizIndex];
          const answer = button.dataset.quizChoice === 'true';
          ensureDailyEntry().quiz = {
            index: quizIndex,
            answer,
            correct: answer === (activePanel.dataset.answer === 'true')
          };
          saveDaily();
        });
      });

      root.addEventListener('shopify:section:unload', stopResetTimer, { once: true });

      const toggleSingleBodyChoice = (buttons, selectedButton) => {
        const shouldSelect = selectedButton.getAttribute('aria-pressed') !== 'true';
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(shouldSelect && button === selectedButton)));
      };

      bodyMoodButtons.forEach((button) => {
        button.addEventListener('click', () => toggleSingleBodyChoice(bodyMoodButtons, button));
      });

      bodySleepButtons.forEach((button) => {
        button.addEventListener('click', () => toggleSingleBodyChoice(bodySleepButtons, button));
      });

      bodySymptomButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const shouldSelect = button.getAttribute('aria-pressed') !== 'true';
          if (button.dataset.bodySymptom === 'none' && shouldSelect) {
            bodySymptomButtons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
            return;
          }
          if (shouldSelect) {
            const noneButton = bodySymptomButtons.find((candidate) => candidate.dataset.bodySymptom === 'none');
            if (noneButton) noneButton.setAttribute('aria-pressed', 'false');
          }
          button.setAttribute('aria-pressed', String(shouldSelect));
        });
      });

      bodySave.addEventListener('click', () => {
        const entry = ensureDailyEntry();
        const body = {
          mood: bodyMoodButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.bodyMood || '',
          sleep: bodySleepButtons.find((button) => button.getAttribute('aria-pressed') === 'true')?.dataset.bodySleep || '',
          symptoms: bodySymptomButtons.filter((button) => button.getAttribute('aria-pressed') === 'true').map((button) => button.dataset.bodySymptom),
          note: bodyNote.value.trim().slice(0, 240)
        };
        if (body.mood || body.sleep || body.symptoms.length || body.note) entry.body = body;
        else entry.body = null;
        saveDaily();
        dailyStatus.textContent = dailyRoot.dataset.bodySaved;
      });

      loadDaily();

      const recipeLibrary = (() => {
        try {
          return JSON.parse(recipesRoot.querySelector('[data-recipe-library]').textContent);
        } catch {
          return {};
        }
      })();

      const appendTextElement = (parent, tagName, text, className = '') => {
        const element = document.createElement(tagName);
        if (className) element.className = className;
        element.textContent = text;
        parent.append(element);
        return element;
      };

      const createRecipeCard = (category, label, rawRecipe, index, isOpen) => {
        const fields = String(rawRecipe || '').split('^');
        const [title, meta, description, ingredientText, stepOne, stepTwo, swap] = fields;
        const card = document.createElement('article');
        card.className = 'cycle-care__recipe-card';
        card.dataset.recipeCard = category;
        const details = document.createElement('details');
        details.className = 'cycle-care__recipe';
        details.dataset.recipeCategory = category;
        details.open = isOpen;

        const summary = document.createElement('summary');
        appendTextElement(summary, 'span', label, 'cycle-care__recipe-tag');
        const heading = document.createElement('span');
        appendTextElement(heading, 'strong', title || label);
        appendTextElement(heading, 'small', meta || '');
        summary.append(heading);
        appendTextElement(summary, 'span', '+', 'cycle-care__recipe-toggle').setAttribute('aria-hidden', 'true');
        details.append(summary);

        const body = document.createElement('div');
        body.className = 'cycle-care__recipe-body';
        appendTextElement(body, 'p', description || '');
        appendTextElement(body, 'h5', recipesRoot.dataset.ingredientsLabel);
        const ingredients = document.createElement('ul');
        String(ingredientText || '').split('~').filter(Boolean).forEach((ingredient) => {
          appendTextElement(ingredients, 'li', ingredient);
        });
        body.append(ingredients);
        appendTextElement(body, 'h5', recipesRoot.dataset.methodLabel);
        const method = document.createElement('ol');
        appendTextElement(method, 'li', stepOne || '');
        appendTextElement(method, 'li', stepTwo || '');
        body.append(method);
        const swapBox = document.createElement('p');
        swapBox.className = 'cycle-care__recipe-swap';
        appendTextElement(swapBox, 'strong', `${recipesRoot.dataset.swapLabel}: `);
        swapBox.append(document.createTextNode(swap || ''));
        body.append(swapBox);
        details.append(body);
        details.style.setProperty('--recipe-index', String(index));
        card.append(details);
        const refreshButton = document.createElement('button');
        refreshButton.type = 'button';
        refreshButton.className = 'cycle-care__recipe-refresh';
        refreshButton.dataset.recipeRefresh = category;
        const refreshKey = `refresh${category.charAt(0).toUpperCase()}${category.slice(1)}`;
        refreshButton.textContent = recipesRoot.dataset[refreshKey];
        card.append(refreshButton);
        return card;
      };

      const renderRecipes = () => {
        const categories = [
          ['breakfast', recipesRoot.dataset.breakfastLabel, 0],
          ['lunch', recipesRoot.dataset.lunchLabel, 4],
          ['dinner', recipesRoot.dataset.dinnerLabel, 8],
          ['snack', recipesRoot.dataset.snackLabel, 12]
        ];
        const utcDay = Math.floor(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) / dayMilliseconds);
        const openCategories = new Set(
          [...recipeGrid.querySelectorAll('details[open]')].map((details) => details.dataset.recipeCategory)
        );
        recipeGrid.replaceChildren();
        categories.forEach(([category, label, categoryOffset], cardIndex) => {
          const recipes = Array.isArray(recipeLibrary[category]) ? recipeLibrary[category] : [];
          if (!recipes.length) return;
          const index = ((utcDay + categoryOffset + recipeOffsets[category]) % recipes.length + recipes.length) % recipes.length;
          recipeGrid.append(createRecipeCard(category, label, recipes[index], cardIndex, openCategories.has(category)));
        });
        recipeDate.textContent = new Intl.DateTimeFormat(locale, {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        }).format(today);
        recipeToday.hidden = Object.values(recipeOffsets).every((offset) => offset === 0);
      };

      recipeAnother.addEventListener('click', () => {
        Object.keys(recipeOffsets).forEach((category) => {
          const categorySize = Array.isArray(recipeLibrary[category]) ? recipeLibrary[category].length : 0;
          if (!categorySize) return;
          recipeOffsets[category] = (recipeOffsets[category] + 1) % categorySize;
          if (recipeOffsets[category] === 0) recipeOffsets[category] = 1;
        });
        recipeStatus.textContent = recipesRoot.dataset.alternateStatus;
        renderRecipes();
      });

      recipeGrid.addEventListener('click', (event) => {
        const button = event.target.closest('[data-recipe-refresh]');
        if (!button) return;
        const category = button.dataset.recipeRefresh;
        if (!(category in recipeOffsets)) return;
        const categorySize = Array.isArray(recipeLibrary[category]) ? recipeLibrary[category].length : 0;
        if (!categorySize) return;
        recipeOffsets[category] = (recipeOffsets[category] + 1) % categorySize;
        if (recipeOffsets[category] === 0) recipeOffsets[category] = 1;
        const statusKey = `refresh${category.charAt(0).toUpperCase()}${category.slice(1)}Status`;
        recipeStatus.textContent = recipesRoot.dataset[statusKey];
        renderRecipes();
      });

      recipeToday.addEventListener('click', () => {
        recipeOffsets = { breakfast: 0, lunch: 0, dinner: 0, snack: 0 };
        recipeStatus.textContent = recipesRoot.dataset.todayStatus;
        renderRecipes();
      });

      renderRecipes();

      const renderWeight = () => {
        const directions = weightDirectionButtons.map((button) => button.dataset.value);
        const habits = weightHabitButtons.map((button) => button.dataset.value);
        if (!directions.includes(weightState.direction)) weightState.direction = 'habits';
        if (!habits.includes(weightState.habit)) weightState.habit = 'regular_meals';
        weightDirectionButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === weightState.direction));
        });
        weightHabitButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.value === weightState.habit));
        });
        const selectedDirection = weightDirectionButtons.find((button) => button.dataset.value === weightState.direction);
        weightDescription.textContent = selectedDirection.dataset.description;
      };

      const loadWeight = () => {
        try {
          const raw = window.localStorage.getItem(weightStorageKey);
          if (raw) {
            const candidate = JSON.parse(raw);
            if (candidate && typeof candidate === 'object') {
              weightState.direction = candidate.direction || 'habits';
              weightState.habit = candidate.habit || 'regular_meals';
            }
          }
        } catch {
          weightStatus.textContent = root.dataset.storageError;
        }
        renderWeight();
      };

      weightDirectionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          weightState.direction = button.dataset.value;
          weightStatus.textContent = '';
          renderWeight();
        });
      });

      weightHabitButtons.forEach((button) => {
        button.addEventListener('click', () => {
          weightState.habit = button.dataset.value;
          weightStatus.textContent = '';
          renderWeight();
        });
      });

      weightSave.addEventListener('click', () => {
        try {
          window.localStorage.setItem(weightStorageKey, JSON.stringify(weightState));
          weightStatus.textContent = root.dataset.weightSaved;
        } catch {
          weightStatus.textContent = root.dataset.storageError;
        }
        renderWeight();
      });

      loadWeight();

      const getOccurrences = () => {
        if (!savedCycle) return [];
        const anchor = parseDate(savedCycle.start);
        const occurrences = [];
        for (let index = -30; index <= 60; index += 1) {
          occurrences.push(addDays(anchor, index * savedCycle.cycleLength));
        }
        return occurrences;
      };

      const labelForTrackedValue = (buttons, key, value) => {
        const button = buttons.find((candidate) => candidate.dataset[key] === value);
        return button ? button.textContent.trim() : value;
      };

      const createCareSummaryText = () => {
        const dateFormatter = new Intl.DateTimeFormat(locale, { dateStyle: 'medium' });
        const lines = [
          careSummaryRoot.dataset.summaryHeading,
          `${careSummaryRoot.dataset.summaryPrepared}: ${dateFormatter.format(today)}`,
          '',
          careSummaryRoot.dataset.summaryPrivateNote,
          '',
          careSummaryRoot.dataset.summaryCycleHeading
        ];

        if (savedCycle) {
          const upcoming = getOccurrences()
            .filter((start) => addDays(start, savedCycle.periodLength - 1) >= today)
            .slice(0, 3)
            .map((start) => dateFormatter.format(start));
          lines.push(
            `${careSummaryRoot.dataset.summaryLastStart}: ${dateFormatter.format(parseDate(savedCycle.start))}`,
            `${careSummaryRoot.dataset.summaryPeriodLength}: ${savedCycle.periodLength} ${careSummaryRoot.dataset.summaryDays}`,
            `${careSummaryRoot.dataset.summaryCycleLength}: ${savedCycle.cycleLength} ${careSummaryRoot.dataset.summaryDays}`,
            `${careSummaryRoot.dataset.summaryNextEstimates}: ${upcoming.length ? upcoming.join(', ') : careSummaryRoot.dataset.summaryNotSaved}`
          );
        } else {
          lines.push(careSummaryRoot.dataset.summaryNoCycle);
        }
        lines.push(careSummaryRoot.dataset.summaryEstimateNote, '', careSummaryRoot.dataset.summaryCheckinsHeading);

        const recentEntries = Object.entries(dailyState.days)
          .map(([key, entry]) => ({ date: parseDate(key), entry }))
          .filter(({ date, entry }) => date && differenceInDays(today, date) >= 0 && differenceInDays(today, date) < 30 && bodyEntryHasContent(entry))
          .sort((left, right) => left.date - right.date);

        if (!recentEntries.length) {
          lines.push(careSummaryRoot.dataset.summaryNoCheckins);
        } else {
          lines.push(`${careSummaryRoot.dataset.summaryDaysLogged}: ${recentEntries.length}`);
          const topMood = mostFrequentBodyValue(recentEntries.map(({ entry }) => entry.body.mood));
          const topSleep = mostFrequentBodyValue(recentEntries.map(({ entry }) => entry.body.sleep));
          const topSymptom = mostFrequentBodyValue(recentEntries.flatMap(({ entry }) => Array.isArray(entry.body.symptoms) ? entry.body.symptoms.filter((value) => value !== 'none') : []));

          if (topMood) lines.push(`${careSummaryRoot.dataset.summaryMood}: ${labelForTrackedValue(bodyMoodButtons, 'bodyMood', topMood[0])} (${topMood[1]})`);
          if (topSleep) lines.push(`${careSummaryRoot.dataset.summarySleep}: ${labelForTrackedValue(bodySleepButtons, 'bodySleep', topSleep[0])} (${topSleep[1]})`);
          if (topSymptom) lines.push(`${careSummaryRoot.dataset.summaryNoted}: ${labelForTrackedValue(bodySymptomButtons, 'bodySymptom', topSymptom[0])} (${topSymptom[1]})`);

          lines.push('', careSummaryRoot.dataset.summaryNotesHeading);
          recentEntries.forEach(({ date, entry }) => {
            const body = entry.body || {};
            const pieces = [];
            if (entry.energy) pieces.push(`${careSummaryRoot.dataset.summaryEnergy}: ${labelForTrackedValue(dailyEnergyButtons, 'dailyEnergy', entry.energy)}`);
            if (body.mood) pieces.push(`${careSummaryRoot.dataset.summaryMoodEntry}: ${labelForTrackedValue(bodyMoodButtons, 'bodyMood', body.mood)}`);
            if (body.sleep) pieces.push(`${careSummaryRoot.dataset.summarySleepEntry}: ${labelForTrackedValue(bodySleepButtons, 'bodySleep', body.sleep)}`);
            if (Array.isArray(body.symptoms) && body.symptoms.length) {
              const symptomLabels = body.symptoms.map((value) => labelForTrackedValue(bodySymptomButtons, 'bodySymptom', value));
              pieces.push(`${careSummaryRoot.dataset.summaryNotedEntry}: ${symptomLabels.join(', ')}`);
            }
            if (body.note) pieces.push(`${careSummaryRoot.dataset.summaryNote}: ${String(body.note).replace(/\s+/g, ' ').trim()}`);
            lines.push(`${dateFormatter.format(date)} — ${pieces.join('; ')}`);
          });
        }

        lines.push('', careSummaryRoot.dataset.summaryDisclaimer);
        return lines.join('\n');
      };

      const renderCareSummary = () => {
        careSummaryText.value = createCareSummaryText();
        careSummaryOutput.hidden = false;
        careSummaryCopy.disabled = false;
        careSummaryDownload.disabled = false;
        careSummaryStatus.textContent = careSummaryRoot.dataset.summaryReady;
        careSummaryText.focus();
      };

      careSummaryCreate.addEventListener('click', renderCareSummary);

      careSummaryCopy.addEventListener('click', async () => {
        if (!careSummaryText.value) renderCareSummary();
        try {
          await navigator.clipboard.writeText(careSummaryText.value);
          careSummaryStatus.textContent = careSummaryRoot.dataset.summaryCopied;
        } catch {
          careSummaryText.focus();
          careSummaryText.select();
          careSummaryStatus.textContent = document.execCommand('copy')
            ? careSummaryRoot.dataset.summaryCopied
            : careSummaryRoot.dataset.summaryCopyFailed;
        }
      });

      careSummaryDownload.addEventListener('click', () => {
        if (!careSummaryText.value) renderCareSummary();
        const file = new Blob([careSummaryText.value], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = careSummaryRoot.dataset.summaryFileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
        careSummaryStatus.textContent = careSummaryRoot.dataset.summaryDownloaded;
      });

      const periodStateForDate = (date) => {
        if (!savedCycle) return '';
        const anchor = parseDate(savedCycle.start);
        const anchorDistance = differenceInDays(date, anchor);
        if (anchorDistance >= 0 && anchorDistance < savedCycle.periodLength) return 'logged';

        const occurrence = getOccurrences().find((start) => {
          const distance = differenceInDays(date, start);
          return distance >= 0 && distance < savedCycle.periodLength;
        });
        return occurrence ? 'estimated' : '';
      };

      const renderCalendar = () => {
        const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' });
        const weekdayFormatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
        const fullDateFormatter = new Intl.DateTimeFormat(locale, { dateStyle: 'full' });
        calendarTitle.textContent = monthFormatter.format(viewMonth);

        const monday = new Date(2024, 0, 1, 12);
        const weekdays = Array.from({ length: 7 }, (_, index) => addDays(monday, index));
        calendarHead.innerHTML = `<tr>${weekdays.map((date) => `<th scope="col">${weekdayFormatter.format(date)}</th>`).join('')}</tr>`;

        const firstDay = new Date(viewMonth.getFullYear(), viewMonth.getMonth(), 1, 12);
        const mondayOffset = (firstDay.getDay() + 6) % 7;
        const gridStart = addDays(firstDay, -mondayOffset);
        const rows = [];

        for (let week = 0; week < 6; week += 1) {
          const cells = [];
          for (let weekday = 0; weekday < 7; weekday += 1) {
            const date = addDays(gridStart, week * 7 + weekday);
            const state = periodStateForDate(date);
            const classes = ['cycle-care__day'];
            if (date.getMonth() !== viewMonth.getMonth()) classes.push('cycle-care__day--outside');
            if (state === 'logged') classes.push('cycle-care__day--logged');
            if (state === 'estimated') classes.push('cycle-care__day--estimated');
            if (dateKey(date) === dateKey(today)) classes.push('cycle-care__day--today');

            const stateLabel = state === 'logged'
              ? root.dataset.currentPeriod
              : state === 'estimated'
                ? root.dataset.estimatedPeriod
                : '';
            const ariaLabel = [fullDateFormatter.format(date), stateLabel].filter(Boolean).join(', ');
            cells.push(`<td><time class="${classes.join(' ')}" datetime="${dateKey(date)}" aria-label="${ariaLabel}">${date.getDate()}</time></td>`);
          }
          rows.push(`<tr>${cells.join('')}</tr>`);
        }
        calendarBody.innerHTML = rows.join('');
      };

      const renderUpcoming = () => {
        if (!savedCycle) {
          results.hidden = true;
          return;
        }

        const dateFormatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric', year: 'numeric' });
        const future = getOccurrences()
          .filter((start) => addDays(start, savedCycle.periodLength - 1) >= today)
          .slice(0, 3);

        upcomingList.innerHTML = future.map((start, index) => {
          const end = addDays(start, savedCycle.periodLength - 1);
          return `<li><span>${index + 1}</span><div><strong>${dateFormatter.format(start)}</strong><small>${dateFormatter.format(start)} - ${dateFormatter.format(end)}</small></div></li>`;
        }).join('');
        results.hidden = false;
      };

      const renderCycleCompass = () => {
        if (!savedCycle) {
          cycleCompassTitle.textContent = root.dataset.cycleCompassEmptyTitle;
          cycleCompassBody.textContent = root.dataset.cycleCompassEmptyBody;
          cycleCompassDay.hidden = true;
          cycleCompassNext.hidden = true;
          return;
        }

        const anchor = parseDate(savedCycle.start);
        const distance = Math.max(0, differenceInDays(today, anchor));
        const cycleNumber = Math.floor(distance / savedCycle.cycleLength);
        const currentStart = addDays(anchor, cycleNumber * savedCycle.cycleLength);
        const currentDay = differenceInDays(today, currentStart) + 1;
        const todayState = periodStateForDate(today);

        if (todayState === 'logged') {
          cycleCompassTitle.textContent = root.dataset.cycleCompassLoggedTitle;
          cycleCompassBody.textContent = root.dataset.cycleCompassLoggedBody;
        } else if (todayState === 'estimated') {
          cycleCompassTitle.textContent = root.dataset.cycleCompassEstimatedTitle;
          cycleCompassBody.textContent = root.dataset.cycleCompassEstimatedBody;
        } else {
          cycleCompassTitle.textContent = root.dataset.cycleCompassBetweenTitle;
          cycleCompassBody.textContent = root.dataset.cycleCompassBetweenBody;
        }

        const nextStart = addDays(currentStart, savedCycle.cycleLength);
        const dateFormatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric', year: 'numeric' });
        cycleCompassDay.textContent = `${root.dataset.cycleDayLabel} ${currentDay}`;
        cycleCompassNext.textContent = `${root.dataset.cycleNextLabel} ${dateFormatter.format(nextStart)}`;
        cycleCompassDay.hidden = false;
        cycleCompassNext.hidden = false;
      };

      const render = () => {
        renderCalendar();
        renderUpcoming();
        renderCycleCompass();
      };

      const load = () => {
        try {
          const raw = window.localStorage.getItem(storageKey);
          if (!raw) {
            render();
            return;
          }
          const candidate = JSON.parse(raw);
          const start = parseDate(candidate.start);
          const periodLength = Number(candidate.periodLength);
          const cycleLength = Number(candidate.cycleLength);
          if (!start || periodLength < 1 || periodLength > 15 || cycleLength < 15 || cycleLength > 90) {
            render();
            return;
          }
          savedCycle = { start: candidate.start, periodLength, cycleLength };
          setDateParts(start);
          periodLengthInput.value = String(savedCycle.periodLength);
          cycleLengthInput.value = String(savedCycle.cycleLength);
        } catch {
          status.textContent = root.dataset.storageError;
        }
        render();
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const start = parseDate(startInput.value);
        const periodLength = Number(periodLengthInput.value);
        const cycleLength = Number(cycleLengthInput.value);
        const valid = start
          && start <= today
          && periodLength >= 1
          && periodLength <= 15
          && cycleLength >= 15
          && cycleLength <= 90;

        if (!valid) {
          status.textContent = root.dataset.invalidMessage;
          return;
        }

        savedCycle = { start: dateKey(start), periodLength, cycleLength };
        try {
          window.localStorage.setItem(storageKey, JSON.stringify(savedCycle));
          status.textContent = root.dataset.savedMessage;
        } catch {
          status.textContent = root.dataset.storageError;
        }
        viewMonth = new Date(today.getFullYear(), today.getMonth(), 1, 12);
        render();
      });

      clearButton.addEventListener('click', () => {
        clearDialog.showModal();
      });

      confirmClearButton.addEventListener('click', () => {
        try {
          window.localStorage.removeItem(storageKey);
          window.localStorage.removeItem(dailyStorageKey);
          window.localStorage.removeItem(weightStorageKey);
        } catch {
          status.textContent = root.dataset.storageError;
          return;
        }
        savedCycle = null;
        dailyState = { focus: 'routine', days: {} };
        weightState = { direction: 'habits', habit: 'regular_meals' };
        form.reset();
        startInput.value = '';
        periodLengthInput.value = '5';
        cycleLengthInput.value = '28';
        status.textContent = root.dataset.clearedMessage;
        dailyStatus.textContent = '';
        weightStatus.textContent = '';
        careSummaryText.value = '';
        careSummaryOutput.hidden = true;
        careSummaryCopy.disabled = true;
        careSummaryDownload.disabled = true;
        careSummaryStatus.textContent = '';
        renderDaily();
        renderWeight();
        render();
      });

      root.querySelector('[data-previous-month]').addEventListener('click', () => {
        viewMonth = new Date(viewMonth.getFullYear(), viewMonth.getMonth() - 1, 1, 12);
        renderCalendar();
      });

      root.querySelector('[data-next-month]').addEventListener('click', () => {
        viewMonth = new Date(viewMonth.getFullYear(), viewMonth.getMonth() + 1, 1, 12);
        renderCalendar();
      });

      load();
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-cycle-care]').forEach(init);
    };

    boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
